// extracted by mini-css-extract-plugin
module.exports = {"story-element-bitgravity-wrapper":"bitgravity-video_story-element-bitgravity-wrapper__1j1cS","story-element-bitgravity":"bitgravity-video_story-element-bitgravity__3KNFU"};